<template>
  <modal
    :width="'400px'"
    :isShow.sync="delDialog"
    title="提示"
    :isShowBtn="[true,true]"
    :btnText="['取消','确认']"
    @clickHandler="ClickHandler"
  >
    <div class="dialog-conter">是否确认删除</div>
  </modal>
</template>

<script>
import modal from '@/components/modal'
import { request } from '@/utils/axios';

export default {
  name: "delModal",
  props: ['contentId','functionsId'],
  data() {
    return {
      delDialog: false,
    }
  },
  methods: {
    ClickHandler(type) {
      if(type==='one') {
        this.delDialog=false
      } else if(type==='two') {
        this.delLiving(this.contentId)
        this.delDialog=false
      }
    },
    delLiving(contentId) {
      request(this.functionsId.delLive,{
        tenantId: this.$commonJs.getTenantId(),
        contentId
      }).then((res)=> {
        if (res) {
          this.$emit('updateRow')
        }
      }).catch(err => {
        this.$message.error(err.msg)
      });
    },
  },
  components: {
    modal
  }
}
</script>

<style scoped>
.dialog-conter {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0 0;
  text-align: center;
  font-weight: 600
}
</style>
